export default __webpack_public_path__ + "static/media/gallery-wip-handle-disc_03.c53ff7f3.jpg";